import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

/** One measured value of a result — a quiet label over the value — for rows of figures. */
export const Metric: React.FC<{ label: string; value: React.ReactNode; mono?: boolean }> = ({ label, value, mono = false }) => {
  const theme = useTheme();
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
      <Typography
        variant="body2"
        component="div"
        sx={{ fontWeight: 500, fontVariantNumeric: 'tabular-nums', fontFamily: mono ? theme.custom.text.mono : undefined }}
      >
        {value}
      </Typography>
    </Box>
  );
};

/** A row of metrics that wraps on a narrow screen. */
export const MetricRow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 3, rowGap: 1.5 }}>{children}</Box>
);
